module.exports = new __parcel__URL__("DataAct.5f4858cc.png").toString();